import { LitElement, css, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { OrderLoadedEvent } from '../../events.js';

@customElement('discount-badge')
export class DiscountBade extends LitElement {
  static styles = css`
    .container {
      border-radius: calc(var(--base-radius) * 0.75);
      padding: calc(var(--base-gap) * 1.25);
      background-color: #ffffffb1;
      box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px,
        rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
        rgba(0, 0, 0, 0.1) 0px 4px 6px -4px;

      border: 2px solid var(--success-color);
    }
  `;

  @state()
  private hasDiscount = false;

  private onOrderLoaded = (orderLoaded: OrderLoadedEvent) => {
    this.hasDiscount = orderLoaded.order?.withDiscount ? true : false;
  };

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(OrderLoadedEvent.event, this.onOrderLoaded);
  }

  render() {
    if (!this.hasDiscount) return nothing;

    return html`
      <div class="container">
        Juhu! Dein Auftrag enthält einen Rabatt!
        <span aria-hidden="true">🥳</span>
      </div>
    `;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener(OrderLoadedEvent.event, this.onOrderLoaded);
  }
}
